import React from "react";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from "@mui/material/TextField";
import {IconButton} from "@mui/material";
import {Cancel} from "@mui/icons-material"

const RubsDatePicker = (params) => {

  const {
    title,
    selected,
    onChange,
    readOnly,
    fullWidth=true,
    isRequired=true,
    errorMessage,
  } = params;

  const hasError = !!errorMessage;

  const _selected = selected ? new Date(selected + "T12:00:00Z") : null;
  const _onChange = (date) => {
    if (date) {
      onChange(date.toISOString().split('T')[0]);
    } else {
      onChange(null);
    }
  }

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  const _onKeyDown = (event) => {
    if (!['ArrowUp', 'ArrowDown'].includes(event.key) || !isValidDate(_selected))
      return;
    const newDate = new Date(_selected);
    const change = event.key === 'ArrowUp' ? 1 : -1;
    newDate.setDate(newDate.getDate() + change);
    onChange(newDate.toISOString().split('T')[0]);
  }

  const _clearButton = isRequired || readOnly ? null :
    <>
      <IconButton size="small" onClick={() => _onChange(null)}>
        <Cancel />
      </IconButton>
      &nbsp;&nbsp;&nbsp;&nbsp;
    </>
  ;

  return <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DesktopDatePicker
      label={title}
      inputFormat="MM/dd/yyyy"
      value={_selected}
      onChange={_onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          error={hasError}
          helperText={hasError ? errorMessage : null}
          fullWidth={fullWidth}
          onKeyDown={_onKeyDown}
          inputProps={
            {
              ...params.inputProps,
              placeholder: "mm/dd/yyyy",
              readOnly: {readOnly},
            }
          }
          InputProps={{
            ...params.InputProps,
            startAdornment: _clearButton,
            endAdornment: readOnly ? null : params.InputProps.endAdornment,
          }}
        />
      )}
    />
  </LocalizationProvider>;
};

export default RubsDatePicker;